import { Injectable } from '@angular/core';
import { filterNilValue, Query } from '@datorama/akita';
import { SettingsStore, SettingsState } from './settings.store';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { Currency } from '../../../shared/components/currency-selector/currency-country-codes';
import * as isoCountries from 'i18n-iso-countries';
import { of } from 'rxjs';
isoCountries.registerLocale(require('i18n-iso-countries/langs/en.json'));

@Injectable({ providedIn: 'root' })
export class SettingsQuery extends Query<SettingsState> {
    availableCurrencies$ = this.select('currenciesAndRates').pipe(
        map((currenciesAndRates) => Object.keys(currenciesAndRates) as Array<Currency>),
        shareReplay(1)
    );

    availableCountries$ = of(
        Object.entries(isoCountries.getNames('en', { select: 'official' }))
            .map(([iso, name]) => ({
                iso,
                flag: iso.toLowerCase(),
                name: name.replace(/ \(The\)/, '')
            }))
            .filter((country) => country.iso)
            .sort((a, b) => a.name.localeCompare(b.name))
    ).pipe(shareReplay(1));

    currenciesAndRates$ = this.select('currenciesAndRates').pipe(
        filterNilValue(),
        distinctUntilChanged(
            (previous, current) => JSON.stringify(current) === JSON.stringify(previous)
        ),
        shareReplay(1)
    );

    getRate = (currency: string) => this.getValue().currenciesAndRates[currency];

    constructor(protected store: SettingsStore) {
        super(store);
    }
}
